/**
 * Wawlabs Search Analytics Events
 * Tek endpoint: POST https://wa.wawlabs.com/  (JSON body, fire-and-forget)
 *
 * 3 event:
 *  1) Search Event        — kullanıcı arama yapıp Enter'a bastığında
 *  2) Product Click Event — arama sonucundaki bir ürüne tıklandığında
 *  3) Add to Cart Event   — arama akışındayken (PLP/PDP) sepete eklendiğinde
 *
 * Arama akışı takibi URL'e dokunulmadan sessionStorage ile yapılır (SEO-güvenli).
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://wa.wawlabs.com/';
  var UID = 'KNZWB-2206787008';
  var KEYWORD_KEY = 'waw_search_keyword';
  var FLOW_KEY = 'waw_search_flow';
  var DEVICE_ID_KEY = 'waw_device_id';

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : '';
  }

  function setCookie(name, value, years) {
    var exp = new Date();
    exp.setFullYear(exp.getFullYear() + (years || 1));
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;expires=' + exp.toUTCString() + ';SameSite=Lax';
  }

  // Guest için kalıcı, KVKK kapsamında olmayan rastgele device id.
  function getDeviceId() {
    var id = getCookie(DEVICE_ID_KEY);
    if (!id) {
      try { id = localStorage.getItem(DEVICE_ID_KEY) || ''; } catch (e) {}
    }
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : ('d-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
      setCookie(DEVICE_ID_KEY, id, 1);
      try { localStorage.setItem(DEVICE_ID_KEY, id); } catch (e) {}
    }
    return id;
  }

  // ga: önce GA4/_ga cookie (örn "GA1.1.123.456"), yoksa login customer id, yoksa device id.
  function getGaId() {
    var ga = getCookie('_ga');
    if (ga) return ga;
    var customerId = window.theme && window.theme.settings && window.theme.settings.favSet && window.theme.settings.favSet.cid;
    if (customerId) return String(customerId);
    return getDeviceId();
  }

  function getDeviceOs() {
    var isMobile = window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : (window.innerWidth < 768);
    return isMobile ? 'desktop_mobile' : 'web';
  }

  function send(body) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        keepalive: true,
        mode: 'cors',
        credentials: 'omit'
      }).catch(function () {});
    } catch (e) {}
  }

  function setKeyword(kw) {
    try { sessionStorage.setItem(KEYWORD_KEY, (kw || '').toString()); } catch (e) {}
  }
  function getKeyword() {
    try { return sessionStorage.getItem(KEYWORD_KEY) || ''; } catch (e) { return ''; }
  }
  // Arama sonucundan bir ürüne tıklanınca akış işareti (PDP'de add-to-cart için).
  function setSearchFlow(kw, productId) {
    try {
      sessionStorage.setItem(FLOW_KEY, JSON.stringify({
        kw: (kw || '').toString(),
        product_id: String(productId || ''),
        ts: Date.now()
      }));
    } catch (e) {}
  }
  function getSearchFlow() {
    try { return JSON.parse(sessionStorage.getItem(FLOW_KEY) || 'null'); } catch (e) { return null; }
  }

  // Göreli URL'i mutlak URL'e çevirir.
  function absUrl(u) {
    if (!u) return '';
    if (/^https?:\/\//i.test(u)) return u;
    if (u.charAt(0) === '/') return window.location.origin + u;
    return window.location.origin + '/' + u;
  }

  // URL'e kullanıcı query'sini ?waw_keyword=<searchText> olarak ekler (mevcutsa günceller).
  function appendKeywordParam(url, searchText) {
    var st = (searchText == null ? '' : searchText).toString();
    if (!st) return url;
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('waw_keyword', st);
      return u.toString();
    } catch (e) {
      var sep = url.indexOf('?') > -1 ? '&' : '?';
      return url + sep + 'waw_keyword=' + encodeURIComponent(st);
    }
  }

  // gid://shopify/Product/123 ya da düz numerik id'den Shopify product id'sini çıkarır.
  function extractProductId(p) {
    if (p == null) return '';
    if (typeof p === 'object') {
      p = p.product_id || p.id || (p.node && (p.node.product_id || p.node.id)) || '';
    }
    var id = String(p);
    var m = id.match(/Product\/(\d+)/);
    if (m) return m[1];
    return /^\d+$/.test(id) ? id : '';
  }

  var WawEvents = {
    ENDPOINT: ENDPOINT,
    UID: UID,
    getGaId: getGaId,
    getDeviceOs: getDeviceOs,
    getDeviceId: getDeviceId,
    setKeyword: setKeyword,
    getKeyword: getKeyword,
    setSearchFlow: setSearchFlow,
    getSearchFlow: getSearchFlow,
    extractProductId: extractProductId,

    // 1) Search Event — Enter / ara aksiyonu
    searchEvent: function (keyword, url) {
      var kw = (keyword || '').toString().trim();
      if (!kw) return;
      setKeyword(kw);
      send({
        enter_search: kw,
        ga: getGaId(),
        uid: UID,
        url: url || '',
        device_os: getDeviceOs()
      });
    },

    // 2) Product Click Event — arama sonucundaki ürüne tıklama
    clickEvent: function (productOrId, keyword, url) {
      var pid = extractProductId(productOrId);
      if (!pid) return;
      var kw = (keyword != null ? keyword : getKeyword()) || '';
      send({
        product_id: pid,
        ga: getGaId(),
        uid: UID,
        url: absUrl(url),
        waw_keyword: kw,
        device_os: getDeviceOs()
      });
    },

    // Ürün tıklamasında hem akış işaretini koyar hem click event'i atar.
    trackProductClick: function (productOrId, keyword, url) {
      var pid = extractProductId(productOrId);
      if (!pid) return;
      var kw = (keyword != null ? keyword : getKeyword()) || '';
      setSearchFlow(kw, pid);
      this.clickEvent(pid, kw, url);
    },

    // 3) Add to Cart Event — uid root'ta, gerisi event objesi altında
    addToCartEvent: function (productOrId, keyword, url) {
      var pid = extractProductId(productOrId);
      if (!pid) return;
      var kw = (keyword != null ? keyword : getKeyword()) || '';
      send({
        uid: UID,
        event: {
          product_id: pid,
          ga: getGaId(),
          url: absUrl(url),
          waw_keyword: kw,
          device_os: getDeviceOs(),
          type: 'addtocart'
        }
      });
    },

    // 4) Type Event — /top_searches ve /search?q= modallarındaki bölümlere tıklama.
    //   type: topquery | topproduct | topbrand | qcategory | qbrand | qpage
    //   opts.keyword    : event.waw_keyword (bölüme göre tıklanan değer ya da boş)
    //   opts.searchText : kullanıcının arama kutusuna yazdığı query. Verilirse
    //     /search?q= bölümleri için (qcategory/qbrand/qpage) kök seviyede waw_keyword
    //     eklenir ve event.url'e ?waw_keyword=<searchText> parametresi yazılır.
    typeEvent: function (type, opts) {
      if (!type) return;
      opts = opts || {};
      var searchText = (opts.searchText == null ? '' : opts.searchText).toString();
      var url = absUrl(opts.url);
      if (searchText) url = appendKeywordParam(url, searchText);
      var body = {
        uid: UID,
        event: {
          product_id: extractProductId(opts.productOrId) || '',
          ga: getGaId(),
          url: url,
          waw_keyword: (opts.keyword || '').toString(),
          device_os: getDeviceOs(),
          type: type
        }
      };
      // Kök seviyede waw_keyword = kullanıcı query'si (yalnızca searchText verildiğinde).
      if (searchText) body.waw_keyword = searchText;
      send(body);
    }
  };

  window.WawEvents = WawEvents;

  // ----- Arama akışı sayfa tespiti -----
  // Akış içi sayfalar: /search PLP'si ve search response redirect'iyle gelinen
  // (hash'inde #from_search olan) koleksiyon/PLP sayfaları.
  // SEO-güvenli: marker query param değil hash; arama motorları yok sayar, canonical'a girmez.
  function isSearchPlp() {
    return window.location.pathname.indexOf('/search') === 0;
  }
  function isFromSearchPage() {
    return (window.location.hash || '').indexOf('from_search') > -1;
  }
  function isInSearchFlowPage() {
    return isSearchPlp() || isFromSearchPage();
  }
  function getFlowKeyword() {
    var q = '';
    try { q = new URLSearchParams(window.location.search).get('q') || ''; } catch (e) {}
    return q || getKeyword() || '';
  }

  // ----- Add-to-cart yakalama (her /cart/add fetch'i) -----
  function handleCartAdd(respJson) {
    var productId = '';
    if (respJson) {
      productId = respJson.product_id ||
        (respJson.items && respJson.items[0] && respJson.items[0].product_id) || '';
    }
    productId = extractProductId(productId);
    if (!productId) return;

    if (isInSearchFlowPage()) {
      // Arama akışı sayfası (PLP veya from_search koleksiyonu) → her ekleme akıştadır.
      WawEvents.addToCartEvent(productId, getFlowKeyword());
      return;
    }

    // Akış dışı sayfa (ör. PDP) → yalnızca arama sonucundan tıklanıp gelinen ürün için.
    var flow = getSearchFlow();
    if (!flow) return;
    if (flow.product_id && String(flow.product_id) !== String(productId)) return;
    WawEvents.addToCartEvent(productId, flow.kw || getKeyword());
  }

  // ----- from_search koleksiyon sayfasında ürün tıklama (Event 2) -----
  // Bu sayfalar tema şablonu olduğu için Alpine @click yok; global capture listener
  // kullanılır. /search PLP'sinde bu listener bağlanmaz (orada Alpine @click var) →
  // çift Event 2 olmaz.
  function getCardProductId(link) {
    var card = link.closest ? link.closest('[id^="product-item--"]') : null;
    if (card && card.id) {
      var m = card.id.match(/-(\d+)$/); // product-item--<section>-<productId>
      if (m) return m[1];
    }
    if (card) {
      var el = card.querySelector('[data-product_id]');
      if (el) return el.getAttribute('data-product_id');
    }
    return '';
  }

  function initFromSearchClicks() {
    if (!isFromSearchPage()) return;
    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[data-grid-link]') : null;
      if (!link) return;
      var pid = getCardProductId(link);
      if (!pid) return;
      WawEvents.trackProductClick(pid, getFlowKeyword());
    }, true);
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isAdd = url && url.indexOf('/cart/add') > -1;
      var promise = origFetch.apply(this, arguments);
      if (isAdd) {
        promise.then(function (res) {
          try {
            res.clone().json()
              .then(function (data) { handleCartAdd(data); })
              .catch(function () { handleCartAdd(null); });
          } catch (e) { handleCartAdd(null); }
        }).catch(function () {});
      }
      return promise;
    };
  }

  initFromSearchClicks();
})();
